import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DESTINACAO_RESERVA } from '../../../../app.constants';
import { MesAnoDTO } from '../../../shared/dominios/DTO/mes-ano.DTO';
import { DestinacaoReservaCompletoModel } from '../../../shared/models/destinacao-reserva-completo.model';
import { DestinacaoReservaModel } from '../../../shared/models/destinacao-reserva.model';


@Injectable()
export class DestinacaoReservaService {


  constructor(private httpClient: HttpClient) { }

  // ENDPOINT DE DESTINAÇÃO RESERVA
  getUltimaData(cdCentrus: number, nrSuperavit: number): Promise<MesAnoDTO> {
    return this.httpClient
      .get<MesAnoDTO>(`${DESTINACAO_RESERVA}/ultimoAno/${cdCentrus}/${nrSuperavit}`)
      .toPromise();
  }

  getListarAnos(cdCentrus: number, nrSuperavit: number): Promise<string[]> {
    return this.httpClient
      .get<string[]>(`${DESTINACAO_RESERVA}/listarAnos/${cdCentrus}/${nrSuperavit}`)
      .toPromise();
  }

  getObterDestinacaoReserva(cdCentrus: number, cdCentrusTit: number, mes: number, ano: number, nrSuperavit: number): Promise<DestinacaoReservaModel> {
    return this.httpClient
      .get<DestinacaoReservaModel>(`${DESTINACAO_RESERVA}/obterDestinacaoReserva/${cdCentrus}/${cdCentrusTit}/${mes}/${ano}/${nrSuperavit}`)
      .toPromise();
  }

  getVerificarDestinacaoReserva(cdCentrus: number, cdCentrusTit: number, mes: number, ano: number, nrSuperavit: number): Promise<number> {
    return this.httpClient
      .get<number>(`${DESTINACAO_RESERVA}/verificarDestinacaoReserva/${cdCentrus}/${cdCentrusTit}/${mes}/${ano}/${nrSuperavit}`)
      .toPromise();
  }

  getVerificarDestinacaoReserva2008Compl(cdCentrus: number, cdCentrusTit: number, mes: number, ano: number): Promise<number> {
    return this.httpClient
      .get<number>(`${DESTINACAO_RESERVA}/verificarDestinacaoReserva2008Compl/${cdCentrus}/${cdCentrusTit}/${mes}/${ano}`)
      .toPromise();
  }

  getObterDestinacaoReservaCompl2008(cdCentrus: number, cdCentrusTit: number, mes: number, ano: number): Promise<DestinacaoReservaCompletoModel> {
    return this.httpClient
      .get<DestinacaoReservaCompletoModel>(`${DESTINACAO_RESERVA}/obterDestinacaoReservaCompl2008/${cdCentrus}/${cdCentrusTit}/${mes}/${ano}`)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/destinacao-reserva/service/destinacao-reserva.service.ts